import { render, staticRenderFns } from "./ExampleDialog.vue?vue&type=template&id=10aff754&scoped=true"
import script from "./ExampleDialog.vue?vue&type=script&lang=ts"
export * from "./ExampleDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExampleDialog.vue?vue&type=style&index=0&id=10aff754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aff754",
  null
  
)

export default component.exports